import Cookies from "js-cookie";
import {axiosInstances} from "../axios-instances";
import {useQuery} from "react-query";

export const getStatistics = async ({url, startDate, endDate, country, filialId, cityId}) => {
  const response = await axiosInstances.get(`${url}`, {
    params: {
      startDate,
      endDate,
      country,
      filialId,
      cityId
    },
    headers: {
      Authorization: `Bearer ${Cookies.get('token')}`,
    }
  });
  if (response.status !== 200) {
    throw new Error(`Error: ${response.status}`);
  }
  return response.data;
}

export const useOrderStatus = ({url, startDate, endDate, country, filialId, cityId}) => {
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: ['statistics', startDate, endDate, country, filialId, cityId],
    queryFn: () => getStatistics({url, startDate, endDate, country, filialId, cityId}),
  });

  return { data, refetch, isLoading, error };
};


export const getStatisticsRound = async (params) => {
  const processedParams = {
    ...params,
    cityId: Array.isArray(params.cityId) 
      ? params.cityId.filter(id => id !== "").join(",") 
      : params.cityId
  };

  const { data } = await axiosInstances.get('/amantrans/statistics/china', {
    headers: {
      Authorization: `Bearer ${Cookies.get('token')}`,
    },
    params: processedParams, 
  });

  return data;
};

export const useStatisticsRound = (params) => {
  const queryKey = ['getStatisticsRound', params]; 
  const { data, refetch, isLoading, error } = useQuery(
    queryKey,
    () => getStatisticsRound(params),
    {
      keepPreviousData: true,
    }
  );

  return { data, refetch, isLoading, error };
};